<script setup lang="ts">
  import { type ButtonHTMLAttributes } from 'vue'
  import type { RouteLocationRaw } from 'vue-router'

  defineProps<{
    to?: RouteLocationRaw,
    loading?: boolean,
    disabled?: boolean,
    type?: ButtonHTMLAttributes['type'],
    href?: string,
    replace?: boolean,
  }>()
  // disabled / loading show button, else show link
</script>

<template>
  <router-link
    v-if="!disabled && !loading && to"
    :to="to"
    :replace="replace">
    <slot></slot>
  </router-link>
  <a
    v-else-if="!disabled && !loading && href"
    :href="href"
    :target="href ? '_blank' : undefined">
    <slot></slot>
  </a>
  <button
    v-else
    class="disabled:cursor-not-allowed"
    :type="type ?? 'button'"
    :disabled="disabled || loading">
    <slot></slot>
    <app-loading-dot v-if="loading" />
  </button>
</template>

<style scoped lang="postcss">
  .btn-primary,
  .btn-danger,
  .btn-low-priority,
  .btn {
    @apply px-4 text-center text-sm flex-center border-1 font-poppins;
    @apply rounded-lg h-9; /* same as .form-control */
  }

  .btn-primary {
    @apply bg-primary hover:bg-primary-400 border-transparent text-white;
  }
  .btn-danger {
    @apply border-transparent bg-red-500 text-white hover:bg-red-400;
  }
  .btn-low-priority {
    @apply border-gray-200 hover:bg-gray-100;
  }

  button:disabled {
    @apply cursor-not-allowed !bg-gray-100 !text-gray-400;
  }

  .btn-icon {
    @apply rounded p-0;
    @apply size-9; /* same as .form-control */
  }

  .gradient-anim {
    text-shadow: 2px 2px 2px rgb(0 0 0 / 20%);
    @apply bg-primary hover:bg-primary-400 text-white;
    @apply relative overflow-hidden !border-0;

    span {
      @apply relative;
    }
  }
  .gradient-anim::before {
    background: linear-gradient(90deg, transparent 0%, #f6d157 50%, transparent 100%);
    animation: gradient 3s linear infinite;
    border: 0 !important;
    @apply inset-y-0 left-0 w-4/5 absolute content-empty;
  }
  @keyframes gradient {
    0% {
      left: -20%;
      opacity: 0;
    }
    40%,
    60% {
      opacity: 1;
    }
    90% {
      opacity: 0;
    }
    100% {
      left: 120%;
      opacity: 0;
    }
  }
</style>
